module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filters"
  }, [(_vm.header) ? [_c('dashboard-panel', {
    attrs: {
      "title": "Contatos pendentes"
    }
  }, [_c('div', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('dropdown-select', {
    staticClass: "field dashboard-filter user-filter pull-right",
    attrs: {
      "options": _vm.users_options
    },
    on: {
      "input": _vm.reloadContacts
    },
    model: {
      value: (_vm.user_filter),
      callback: function($$v) {
        _vm.user_filter = $$v
      },
      expression: "user_filter"
    }
  })], 1)])] : [_c('h2', {
    staticClass: "inline"
  }, [_vm._v("Contatos pendentes")]), _c('dropdown-select', {
    staticClass: "field pull-right",
    attrs: {
      "options": _vm.users_options
    },
    on: {
      "input": _vm.reloadContacts
    },
    model: {
      value: (_vm.user_filter),
      callback: function($$v) {
        _vm.user_filter = $$v
      },
      expression: "user_filter"
    }
  }), _c('br'), _c('br')], _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadContacts),
      expression: "loadContacts"
    }],
    class: _vm.getClass(),
    attrs: {
      "infinite-scroll-distance": "10"
    }
  }, [_c('contact-list', {
    attrs: {
      "contacts": _vm.contacts,
      "view_mode": _vm.contactListViewModes().paused_contacts,
      "filters": {}
    },
    on: {
      "contact-update": _vm.updateContact,
      "contact-recipient-update": _vm.updateContactRecipient,
      "toggle-task-bar": _vm.bubbleUp
    }
  }), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.loading
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.next_page),
      expression: "!next_page"
    }],
    staticClass: "light-gray-text light-text"
  }, [_vm._v("Sem mais resultados")])], 1)], 1), _c('reactivate-recipient-modal', {
    attrs: {
      "contact": _vm.schedule_reactivation_contact
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ddcd6ed4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manual_tasks/paused_contacts.vue
// module id = 1222
// module chunks = 1